var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{staticClass:"chartCanvas",attrs:{"id":`canvas_${this.title}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }